// Browser storage keys shared between services (kept apart from the services to avoid import cycles).

// sessionStorage: agent selected by a power user / admin to act on his behalf (US 7.8, SurveyActorService).
export const SURVEY_ACTING_AS_STORAGE_KEY = 'survey-acting-as';
